module.exports = __webpack_public_path__ + "static/media/the-game-cricket-2025.93aa00c7.png";